import * as React from 'react';
import { useEditController, useRefresh } from 'react-admin';
import { NewsForm } from './NewsForm';
import { Edit } from '../../components/Edit';
import { RecordEditTitle } from '../../components/RecordTitle';
import { transformMediaUrlInput } from '../../lib/media/makeUrl'
import { fromGenericToUTC } from '../../lib/i18n/utils';

export const NewsEdit = (props: any) => {
  const { record, isLoading } = useEditController();
  const refresh = useRefresh();
  const transform = data => ({
    ...data,
    publishedAt: fromGenericToUTC(data.publishedAt),
    agendaIds: data.agendaIds ?? [],
    topicIds: data.topicIds ?? [],
    sectorIds: data.sectorIds ?? [],
    mediaUrl: transformMediaUrlInput(data.mediaUrl)
  });

  React.useEffect(() => {
    if (record && record.id) {
      refresh();
    }
  }, [record, refresh]);

  if (isLoading || !record.createdBy) return null;

  return (
    <Edit mutationMode='pessimistic' meta={{ embed: 'media,sectors,topics' }} title={<RecordEditTitle property="title" />} {...props} transform={transform}>
      <NewsForm username={record.createdBy.name} hideSendPushNotification hideAgenda />
    </Edit>
  )
};
